import styled from "styled-components";



export const InputContainer = styled.div`
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
  position: relative;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
`;

export const Radio = styled.input`
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
`;